<!--
 * @Author: fengxiaojing
 * @LastEditTime: 2022-05-13 16:34:07
 * @Description: 报警信息
 * @LastEditors: Please set LastEditors
-->
<template>
  <div
    v-drag
    class="position-absolute alarm_info"
    :style="{ left: isShowBasicCom ? '405px' : '35px' }"
  >
    <div class="business_dialog_title m-b-5">
      <span class="fz-14 text-color-white">报警信息</span>
      <span
        class="iconfont icon-close text-color-white r close_icon"
        @click="closeComponent"
      ></span>
    </div>
    <el-tabs class="w-100 h-100 position-relative" v-model="activeName" type="card">
      <el-tab-pane label="SIS报警" name="first">
        <SISAlarm></SISAlarm>
      </el-tab-pane>
      <el-tab-pane label="围栏报警" name="second">
        <fenceAlarm></fenceAlarm>
      </el-tab-pane>
      <el-tab-pane label="周界报警" name="third">
        <perimeterAlarm></perimeterAlarm>
      </el-tab-pane>
      <el-tab-pane label="门禁报警" name="fourth">
        <entranceGuardAlarm></entranceGuardAlarm>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
const SISAlarm = () => {
  return import('./components/SISAlarm')
}
const fenceAlarm = () => {
  return import('./components/fenceAlarm')
}
const perimeterAlarm = () => {
  return import('./components/perimeterAlarm')
}
const entranceGuardAlarm = () => {
  return import('./components/entranceGuardAlarm')
}

export default {
  name: 'AlarmInfo',
  props: ['isShowBasicCom'],
  components: {
    fenceAlarm,
    SISAlarm,
    perimeterAlarm,
    entranceGuardAlarm,
  },
  data() {
    return {
      activeName: 'first',
    }
  },
  methods: {
    closeComponent() {
      this.$emit('closeComponent', 'AlarmInfo')
    },
  },
}
</script>
<style lang="scss">

@import '../../../css/select.scss';

</style>
<style lang="scss" scoped>

@import '../../../css/index.scss';
.alarm_info {
  height: 500px;
  width: 750px;
  top: 66px;
  padding: 10px;
  background-color: rgba(46, 107, 176, 0.5) !important;
  border-radius: 4px;
  z-index: 99;
}
/deep/.el-tabs__content {
  height: calc(100% - 60px);
}
/deep/.el-tab-pane {
  height: calc(100% - 30px);
}
/deep/.el-tabs__header {
  margin-bottom: 0px;
}
/deep/.el-tabs__item {
  height: 30px;
  line-height: 30px;
  padding: 0 10px;
}
/deep/ .el-table {
  thead th {
    padding: 0px;
  }
  &__body-wrapper {
    height: calc(100% - 15px);
    overflow-y: scroll;
  }
}
.close_icon {
  z-index: 99;
}

</style>
